<template>
    <div class="phi-block-obligations-report">
        <section v-if="action != 'delete'">
            <div v-if="!post" v-html="body"></div>
            <div v-else>
                <div style="display: flex; gap: 10px;">
                    <div style="">{{ $t('Select the entity to notify') }}</div>
                    <select name="test" id="test" v-model="entitySelected">
                        <option v-for="entity in entities" :key="entity.id" :value="entity.id">{{ entity.name ? entity.name : $t('Default') }}</option>
                    </select>
                </div>
                <br>
                <table border='0' cellspacing='0' cellpadding='0' width='100%' style='font-size: 12px;' class='table_responsive'>
                    <thead>
                        <tr>
                            <td>#</td>
                            <td>{{ $t('Student') }}</td>
                            <td>{{ $t('Period') }}</td>
                            <td>{{ $t('Issue date') }}</td>
                            <td>{{ $t('Expiration date') }}</td>
                            <td align="right" width="120px">{{ $t('Value') }}</td>
                            <td align="right" width="120px">{{ $t('Discount') }}</td>
                            <td align="right" width="120px">{{ $t('Payment') }}</td>
                            <td align="right" width="120px">{{ $t('Interests') }}</td>
                            <td align="right" width="120px">{{ $t('Total') }}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="color: rgb(177, 177, 177);">
                            <td>0000</td>
                            <td>{{ $t('Student') }}</td>
                            <td>{{ $t('Period') }}</td>
                            <td>01 Ene 2024</td>
                            <td>01 Ene 2024</td>
                            <td align="right">$0</td>
                            <td align="right">$0</td>
                            <td align="right">$0</td>
                            <td align="right">$0</td>
                            <td align="right">$0</td>
                        </tr>
                    </tbody>
                </table>
                <small style="color: red;">{{ $t('This is preview data of what senders will see.') }}</small>
            </div>
        </section>

        <section class="delete" v-if="action == 'delete'">
            <h1>{{ $t('Remove statement block?') }}</h1>
            <button type="button" class="phi-button danger" @click="$emit('destroy')">{{$t('action.delete')}}</button>
            <button type="button" class="phi-button cancel" @click="$emit('reset')">{{$t('action.cancel')}}</button>
        </section>
    </div>
</template>

<script>
export default {
    phiBlock: {
        title: "obligationsReport",
        icon: "payments",
        actions: {
            delete: {
                title: "delete"
            }
        }
    },
    name: "phi-block-obligations-report",
    props: ["block", "action", "post"],
    data() {
		return {
            body: null,
            entities: [],
            entitySelected: null
		}
	},
    created() {
        this.getEntities();
        if (!this.block.url) {
            let baseUrl = this.$store.state.url.replace(".api", "");
            var fechaActual = new Date();
            // fechaActual.setHours(0, 0, 0, 0);
            var timestampFechaActual = Math.floor(fechaActual.getTime());
            this.block.url = `${baseUrl}/debit/expired?person=${this.$store.state.user.id}&date=${timestampFechaActual}&entity=${this.entitySelected}&datetime=true`;
            this.$emit("change");
        } else {
            this.reload();
        }
    },
    watch: {
        entitySelected(newValue){
            var url = new URL(this.block.url);
            url.searchParams.set("entity", newValue);
            this.block.url = url.toString();
        },
    },
    methods: {
        async getEntities() {
            try {
                this.entities = await this.$store.state.api.get("/v3/billing/entities");

                if (!Array.isArray(this.entities)) {
                this.entities = [];
                }
            } catch (err) {
                this.entities = [];
            }
        },
        reload() {
            var urlCompleta = window.location.href;
            var url = new URL(urlCompleta);
            var valorPerson = url.searchParams.get("person") ? url.searchParams.get("person") : this.$store.state.user.id;

            var urlObj = new URL(this.block.url);
            urlObj.searchParams.set("person", valorPerson);
            var newURLBlock = urlObj.toString();

            fetch(newURLBlock, {
                headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                },
            })
            .then((response) => response.text())
            .then((body) => this.body = body);
        },
    },
    i18n: {
        "en": {
            "Student": "Student",
            "Period": "Period",
            "Issue date": "Issue date",
            "Expiration date": "Expiration date",
            "Value": "Value",
            "Discount": "Discount",
            "Payment": "Payment",
            "Interests": "Interests",
            "Total": "Total",
            "This is preview data of what senders will see.": "This is preview data of what senders will see.",
            "Remove statement block?": "Remove statement block?",
            "Select the entity to notify": "Select the entity to notify",
            "Default": "Default"
        },

        "es": {
            "Student": "Estudiante",
            "Period": "Periodo",
            "Issue date": "Fecha de expedición",
            "Expiration date": "Fecha de vencimiento",
            "Value": "Valor",
            "Discount": "Descuento",
            "Payment": "Pago",
            "Interests": "Intereses",
            "Total": "Total",
            "This is preview data of what senders will see.": "Estos son datos de previsualización de lo que van a ver los remitentes.",
            "Remove statement block?": "Eliminar bloque de estado de cuenta?",
            "Select the entity to notify": "Seleccione la entidad a notificar",
            "Default": "Predeterminada"
        },

        "it": {
            "Student": "Studente",
            "Period": "Periodo",
            "Issue date": "Data di emissione",
            "Expiration date": "Data di scadenza",
            "Value": "Valore",
            "Discount": "Sconto",
            "Payment": "Pagamento",
            "Interests": "Interessi",
            "Total": "Totale",
            "This is preview data of what senders will see.": "Si tratta di un'anteprima dei dati che i mittenti vedranno.",
            "Remove statement block?": "Rimuovere il blocco delle dichiarazioni?",
            "Select the entity to notify": "Selezionare l'entità da notificare",
            "Default": "Predefinito"
        },

        "fr": {
            "Student": "étudiant",
            "Period": "Période",
            "Issue date": "Date d'émission",
            "Expiration date": "Date d'expiration",
            "Value": "Valeur",
            "Discount": "Remise",
            "Payment": "Paiement",
            "Interests": "Intérêts",
            "Total": "Total",
            "This is preview data of what senders will see.": "Il s'agit de données de prévisualisation de ce que les expéditeurs verront.",
            "Remove statement block?": "Supprimer le bloc de déclaration ?",
            "Select the entity to notify": "Sélectionner l'entité à notifier",
            "Default": "Par défaut"
        },

        "de": {
            "Student": "Studenten",
            "Period": "unterrichtsstunde",
            "Issue date": "ausstellungsdatum",
            "Expiration date": "ablaufdatum",
            "Value": "Wert",
            "Discount": "Rabatt",
            "Payment": "Zahlung",
            "Interests": "zinsen",
            "Total": "insgesamt",
            "This is preview data of what senders will see.": "Dies sind Vorschaudaten dessen, was die Absender sehen werden.",
            "Remove statement block?": "Anweisungsblock entfernen?",
            "Select the entity to notify": "Wählen Sie die zu benachrichtigende Einheit",
            "Default": "Standard"
        },

        "pt": {
            "Student": "Estudante",
            "Period": "Período",
            "Issue date": "Data de emissão",
            "Expiration date": "Data de expiração",
            "Value": "Valor",
            "Discount": "Desconto",
            "Payment": "Pagamento",
            "Interests": "Interesse",
            "Total": "Total",
            "This is preview data of what senders will see.": "Estes são dados de pré-visualização do que os remetentes irão ver.",
            "Remove statement block?": "Remover bloco de declaração?",
            "Select the entity to notify": "Selecionar a entidade a notificar",
            "Default": "Predefinição"
        }
    }
}
</script>